import { createFileRoute } from "@tanstack/react-router"

import { PlaceholderPanel } from "@/components/shared/PlaceholderPanel"

export const Route = createFileRoute("/portfolio/financial")({
  component: () => (
    <PlaceholderPanel
      title="Financial Overview"
      description="Budget vs. actual, QSBS 5-test dashboard, capital allocation tracker, intercompany service fees"
    />
  ),
})
